
// Vue
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { namespace } from "vuex-class";

// Types
import { Region } from "@/store/types";

// Namespaces
const Regions = namespace("regions");

@Component({
})

export default class RegionDeleteModal extends Vue {
	// Props
	@Prop({ default: null, type: Object }) selectedRegion: Region;
	@Prop({ default: false, type: Boolean }) visible: boolean;

	// Actions
    @Regions.Action deleteRegion: (regionId: number) => Promise<void>;

	@Emit("toggle-modal")
	private closeModal(): void {}

	private async removeRegion(): Promise<void> {
		await this.deleteRegion(this.selectedRegion.regionId);
		this.closeModal();
	}
}
